import React, { useContext } from 'react'
import { Form, Radio } from 'antd'
import { Select } from '@seiue/ui'
import { QuestionTypeEnum } from 'packages/sdks-next/growp'
import { questionTypeEnumToLabel } from '../../../utils'
import { EditProductQuestionItemProps } from '../../types'
import { editSubQuestion } from '../../utils'
import { JudgeMode } from '@/features/test-paper/types'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'

export const EditSubType: React.FC<EditProductQuestionItemProps> = ({
  curQuestion,
  treeNodeId,
  subQuestions,
  setSubQuestions,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  const typeOptions = questionTypeEnumToLabel
    .listOptions('value', 'label')
    .filter((i) => {
      return (
        i.value !== QuestionTypeEnum.TrueOrFalse &&
        i.value !== QuestionTypeEnum.Product
      )
    })
  return (
    <>
      <Form.Item
        label="题型"
        required
        rules={[
          {
            required: true,
            message: '请选择题型',
          },
        ]}
      >
        <Select
          disabled={limitLevel > 0}
          style={{
            width: '360px',
            height: '32px',
          }}
          options={typeOptions}
          placeholder="请选择"
          onChange={(v) => {
            const newSubQuestions = editSubQuestion(
              subQuestions,
              treeNodeId || 0,
              {
                type: v,
                standardAnswers: [],
                score: undefined,
                options: [
                  QuestionTypeEnum.SingleChoice,
                  QuestionTypeEnum.MultipleChoice,
                ].includes(v)
                  ? curQuestion.options?.length
                    ? curQuestion.options
                    : ['A', 'B', 'C', 'D']
                  : [],
                settings: {
                  JudgeMode: JudgeMode.Auto,
                },
              }
            ).filter((q) => q.treeNodePid !== treeNodeId)
            setSubQuestions(newSubQuestions)
          }}
          value={curQuestion?.type || QuestionTypeEnum.SingleChoice}
        />
      </Form.Item>
      {curQuestion.type === QuestionTypeEnum.FillInBlank ? (
        <Form.Item label="类型">
          <Radio.Group
            disabled={limitLevel > 0}
            options={[
              { label: '自动判题', value: JudgeMode.Auto },
              {
                label: '手动判题',
                value: JudgeMode.Manual,
              },
            ]}
            defaultValue={JudgeMode.Auto}
            value={curQuestion.settings?.judgeMode || JudgeMode.Auto}
            onChange={(e) => {
              const mode = e.target.value
              // 模式转换后删除子题
              const newSubQuestions = subQuestions.filter(
                (q) => q.treeNodePid !== treeNodeId
              )
              const finalNewSubQuestions = editSubQuestion(
                newSubQuestions,
                treeNodeId || 0,
                {
                  settings: { ...curQuestion.settings, judgeMode: mode },
                }
              )
              setSubQuestions(finalNewSubQuestions)
            }}
          />
        </Form.Item>
      ) : null}
    </>
  )
}
